import React, { useState, useEffect } from 'react';
import Toggle from '../../../Common/Toggle/Toggle';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const SituacaoCadastral = () => {
  const [situacoesCadastrais, setSituacoesCadastrais] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    situacao: '',
    descricao: '',
    ativo: true
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const carregarSituacoes = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/situacao-cadastral`
      );
      if (!response.ok) {
        throw new Error('Erro ao buscar situações cadastrais');
      }
      const data = await response.json();
      const formatadas = data.map((item) => ({
        id: item.id_situacao,
        situacao: item.nome_situacao,
        descricao: '',
        ativo: item.ativo
      }));
      setSituacoesCadastrais(formatadas);
    } catch (error) {
      console.error('Erro ao carregar situações cadastrais:', error);
      alert(
        'Erro ao carregar situações cadastrais. Verifique a conexão com o servidor.'
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSituacoes();
  }, []);

  const filteredSituacoesCadastrais = situacoesCadastrais.filter((situacao) =>
    (situacao.situacao || '')
      .toLowerCase()
      .includes(searchTerm.toLowerCase()) ||
    (situacao.descricao || '')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      const payload = {
        nome_situacao: formData.situacao,
        ativo: formData.ativo
      };

      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/situacao-cadastral/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar situação cadastral');
        }

        const atualizada = await response.json();

        setSituacoesCadastrais(
          situacoesCadastrais.map((situacao) =>
            situacao.id === editingId
              ? {
                  id: atualizada.id_situacao,
                  situacao: atualizada.nome_situacao,
                  descricao: situacao.descricao,
                  ativo: atualizada.ativo
                }
              : situacao
          )
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/situacao-cadastral`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar situação cadastral');
        }

        const criada = await response.json();

        setSituacoesCadastrais([
          ...situacoesCadastrais,
          {
            id: criada.id_situacao,
            situacao: criada.nome_situacao,
            descricao: formData.descricao,
            ativo: criada.ativo
          }
        ]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar situação cadastral:', error);
      alert(
        'Erro ao salvar situação cadastral. Verifique os dados e tente novamente.'
      );
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (situacaoCadastral) => {
    setFormData({
      situacao: situacaoCadastral.situacao,
      descricao: situacaoCadastral.descricao,
      ativo: situacaoCadastral.ativo
    });
    setEditingId(situacaoCadastral.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (
      window.confirm(
        'Tem certeza que deseja excluir esta situação cadastral?'
      )
    ) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/situacao-cadastral/${id}`,
          {
            method: 'DELETE'
          }
        );

        if (!response.ok && response.status !== 204) {
          throw new Error('Erro ao excluir situação cadastral');
        }

        setSituacoesCadastrais(
          situacoesCadastrais.filter((situacao) => situacao.id !== id)
        );
      } catch (error) {
        console.error('Erro ao excluir situação cadastral:', error);
        alert('Erro ao excluir situação cadastral. Tente novamente.');
      }
    }
  };

  const resetForm = () => {
    setFormData({
      situacao: '',
      descricao: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const selecionada = situacoesCadastrais.find((s) => s.id === id);
    if (!selecionada) {
      return;
    }

    const novoAtivo = !selecionada.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/situacao-cadastral/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            nome_situacao: selecionada.situacao,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status da situação cadastral');
      }

      setSituacoesCadastrais(
        situacoesCadastrais.map((situacao) =>
          situacao.id === id ? { ...situacao, ativo: novoAtivo } : situacao
        )
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status da situação cadastral:',
        error
      );
      alert(
        'Erro ao atualizar status da situação cadastral. Tente novamente.'
      );
    }
  };

  return (
    <div className="tabela-referencia-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Situação Cadastral</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
            disabled={saving}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            Cadastrar Situação
          </button>
        )}
      </div>

      {showForm ? (
        <div className="form-container">
          <div className="form-header">
            <h2>{editingId ? 'Editar Situação Cadastral' : 'Cadastrar Situação Cadastral'}</h2>
            <button className="btn-close" onClick={resetForm}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M18 6L6 18M6 6l12 12"/>
              </svg>
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="situacao">Situação *</label>
              <input
                type="text"
                id="situacao"
                value={formData.situacao}
                onChange={(e) => setFormData({...formData, situacao: e.target.value})}
                required
                maxLength={100}
                placeholder="Digite a situação cadastral"
              />
            </div>

            <div className="form-group">
              <label htmlFor="descricao">Descrição</label>
              <textarea
                id="descricao"
                value={formData.descricao}
                onChange={(e) => setFormData({...formData, descricao: e.target.value})}
                placeholder="Digite a descrição da situação"
                rows="4"
              />
            </div>

            <div className="form-group">
              <Toggle
                id="ativo"
                label="Status:"
                checked={formData.ativo}
                onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
              />
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm} disabled={saving}>
                Cancelar
              </button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <input
                type="text"
                placeholder="Pesquisar situações..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>
                {loading
                  ? 'Carregando situações cadastrais...'
                  : `${filteredSituacoesCadastrais.length} registro(s) encontrado(s)`}
              </span>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Situação</th>
                  <th>Descrição</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
            <tbody>
              {filteredSituacoesCadastrais.map(situacao => (
                <tr key={situacao.id}>
                  <td>{situacao.id}</td>
                  <td>{situacao.situacao}</td>
                  <td className="contexto-cell">{situacao.descricao}</td>
                  <td className="status-cell">
                    <div className="status-toggle-wrapper">
                      <Toggle
                        checked={situacao.ativo}
                        onChange={() => handleToggleStatus(situacao.id)}
                        id={`toggle-${situacao.id}`}
                      />
                    </div>
                  </td>
                  <td className="acoes-col">
                    <div className="action-buttons">
                      <button 
                        className="btn-edit"
                        onClick={() => handleEdit(situacao)}
                        title="Editar"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                        </svg>
                      </button>
                      <button 
                        className="btn-delete"
                        onClick={() => handleDelete(situacao.id)}
                        title="Excluir"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <polyline points="3,6 5,6 21,6"/>
                          <path d="M19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2"/>
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {filteredSituacoesCadastrais.length === 0 && !loading && (
            <div className="empty-state">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <h3>Nenhuma situação encontrada</h3>
              <p>Tente ajustar os filtros de pesquisa ou cadastre uma nova situação.</p>
            </div>
          )}
        </div>
        </div>
      )}
    </div>
  );
};

export default SituacaoCadastral;
